<template>
    <div>
        <zm-row>
            <zm-button size="small" @click="showCreate()" class="btn-in-line" v-if="role === 'SUPER_ADMIN'" type="primary">create cluster</zm-button>
            <zm-button size="small" @click="fetchData()" class="btn-in-line" plain>show all</zm-button>
            <zm-button size="small" @click="showMigration()" class="btn-in-line" v-if="hasPermission" plain>migration topics</zm-button>
            <zm-button size="small" @click="showDC()" class="btn-in-line" plain>show DCs</zm-button>
            <zm-button size="small" @click="showSummary()" class="btn-in-line" plain>show Summary</zm-button>
            <zm-button size="small" @click="showMQ()" class="btn-in-line" plain :loading="mqLoading">upload from kafka manage</zm-button>
            <zm-input size="small" placeholder="input to search" v-model.trim="search" class="search-input"></zm-input>
        </zm-row>
        <div class="table-container">
            <zm-table resizable border :data="tableData.slice((pageable.pageNumber - 1) * pageable.pageSize, pageable.pageNumber * pageable.pageSize)"
            @expand-change="expandHandler" @sort-change="onSort" :init-displayed-column="initDisplayedColumn"
            :default-sort = "{prop: 'dcName', order: 'descending'}"
            v-loading="loading" :row-class-name="tableRowClassName">
                <zm-table-column prop="expand" type="expand">
                    <template slot-scope="scope">
                        <channel-detail :id="scope.row.id"></channel-detail>
                    </template>
                </zm-table-column>
                <zm-table-column prop="dcName" label="dcName" align="center" :show-overflow-tooltip="true" sortable width="110px">
                </zm-table-column>
                <zm-table-column prop="groupName" label="groupName" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column prop="channelName" label="clusterName" sortable :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column prop="currentLoads" label="currentLoads" align="center" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column prop="weight" label="weight" align="center" :show-overflow-tooltip="true" width="90px">
                </zm-table-column>
                <zm-table-column prop="sensitiveConfigurationType" label="sensitiveConfigurationType" align="center" :show-overflow-tooltip="true" width="210px">
                </zm-table-column>
                <zm-table-column prop="clusterStartupStatus" width="160px" label="clusterStartupStatus" align="center" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column prop="broadcast" width="90px" label="broadcast" align="center">
                    <template slot-scope='scope'>
                        <i class='glyphicon' :class="{'zm-icon-ok':scope.row.broadcast,'zm-icon-close':!scope.row.broadcast}"></i>
                    </template>
                </zm-table-column>
                <zm-table-column prop="active" width="60px" label="active" align="center">
                    <template slot-scope='scope'>
                        <i class='glyphicon' :class="{'zm-icon-ok':scope.row.active,'zm-icon-close':!scope.row.active}"></i>
                    </template>
                </zm-table-column>
                <zm-table-column prop="endPoint" label="endPoint" align="center" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column prop="operate" label="operate" width="150px">
                    <template slot-scope="scope">
                        <zm-button size="small" class="btn-contain" type="icon" title="edit cluster" icon="zm-icon-edit" v-if="hasPermission" @click="showEditChannel(scope.row)"></zm-button>
                        <zm-button size="small" class="btn-contain" type="icon" title="enable cluster" icon="zm-icon-play" v-if="!scope.row.active && hasPermission" @click="activeChannel(scope.row)"></zm-button>
                        <zm-button size="small" class="btn-contain" type="icon" title="disable cluster" icon="zm-icon-pause" v-if="scope.row.active && hasPermission" @click="activeChannel(scope.row)"></zm-button>
                        <zm-dropdown class="btn-contain" @command="handleCommand" trigger="click">
                            <zm-button type="icon" icon="zm-icon-more" class="btn-contain" :loading="scope.row.loading"></zm-button>
                            <zm-dropdown-menu slot="dropdown">
                                <zm-dropdown-item v-if="hasPermission"
                                    :command="{command: 'refreshChannel', param: scope.row}">
                                    Refresh Cluster
                                </zm-dropdown-item>
                                <zm-dropdown-item v-if="hasPermission"
                                    :command="{command: 'resetChannel', param: scope.row}">
                                    Reset Cluster
                                </zm-dropdown-item>
                                <zm-dropdown-item v-if="hasPermission && isKafka"
                                    :command="{command: 'openUpload', param: scope.row}">
                                    Upload Kafka SSL JKS
                                </zm-dropdown-item>
                                <zm-dropdown-item :command="{command: 'showDescribe', param: scope.row}">
                                    Show Describe
                                </zm-dropdown-item>
                                <zm-dropdown-item v-if="hasPermission && scope.row.clusterStartupStatus !== 'READY'"
                                    :command="{command: 'showRecovery', param: scope.row.id}">
                                    Recovery
                                </zm-dropdown-item>
                                <zm-dropdown-item v-if="hasPermission"
                                    :command="{command: 'showExpand', param: scope.row}">
                                    Expand
                                </zm-dropdown-item>
                                <zm-dropdown-item v-if="hasPermission"
                                    :command="{command: 'showVerify', param: scope.row}">
                                    Verify
                                </zm-dropdown-item>
                                <zm-dropdown-item v-if="role === 'SUPER_ADMIN' && !scope.row.active"
                                    :command="{command: 'deleteChannel', param: scope.row.id}">
                                    Delete Channel
                                </zm-dropdown-item>
                                <zm-dropdown-item
                                    :command="{command: 'showMonitor', param: scope.row.id}">
                                    Show Monitor
                                </zm-dropdown-item>
                                <zm-dropdown-item v-if="hasPermission && scope.row.active"
                                    :command="{command: 'showAssignHotBackup', param: scope.row}">
                                    Assign HotBackup
                                </zm-dropdown-item>
                            </zm-dropdown-menu>
                        </zm-dropdown>
                    </template>
                </zm-table-column>
            </zm-table>
            <div style="text-align: center" class="pagination-wrap">
                <zm-pagination
                    @size-change="handleSizeChange"
                    :current-page.sync="pageable.pageNumber"
                    :page-size="pageable.pageSize"
                    :page-sizes="[10, 20, 50, 100, 500, 1000]"
                    layout="sizes, total, prev, pager, next, jumper"
                    :total="tableData.length">
                </zm-pagination>
            </div>
        </div>
        <zm-dialog title="Upload Client Trust Store File" :visible.sync="uploadVisible" width="600px">
            <zm-form :model="uploadData" label-position="left" ref="uploadData" :rules="uploadRules" label-width="140px">
                <zm-form-item label="clientSSLPassword" prop="clientSSLPassword">
                    <div slot="label">
                        <tip label="clientSSLPassword" id="channel-upload-clientSSLPassword"></tip>
                    </div>
                    <zm-input size="small" v-model="uploadData.clientSSLPassword"></zm-input>
                </zm-form-item>
                <zm-form-item label="sslEndPoint" prop="sslEndPoint">
                    <div slot="label">
                        <tip label="sslEndPoint" id="channel-upload-sslEndPoint"></tip>
                    </div>
                    <zm-input size="small" v-model="uploadData.sslEndPoint"></zm-input>
                </zm-form-item>
                <zm-form-item label-width="0" align="center">
                    <zm-upload
                        class="upload-demo"
                        drag
                        :action="getAction()"
                        :headers="headers"
                        :on-success="uploadSuccess"
                        :on-error="uploadError"
                        :data="uploadData"
                        ref="upload"
                        id="demo-upload"
                        :file-list="fileList"
                        :http-request="sslUpload"
                        :auto-upload="false">
                        <i class="zm-icon-upload"></i>
                        <div class="zm-upload__text">Drop file here or <em>click to upload</em></div>
                        <!-- <zm-button size="small" type="primary">select file</zm-button> -->
                        <!-- <zm-button size="small" class="btn-contain" type="icon" title="upload" icon="zm-icon-upload"></zm-button> -->
                    </zm-upload>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="uploadVisible = false">Cancel</zm-button>
                <zm-button size="small" style="margin-left: 10px;"  type="primary" @click="submitUpload" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog :title="form.title" :visible.sync="dialogFormVisible" @close="resetForm">
            <zm-form :model="form" label-position="left" ref="form" :rules="rules" :label-width="formLabelWidth">
                <zm-form-item label="clusterName" prop="channelName">
                    <div slot="label">
                        <tip label="clusterName" id="channel-clusterName"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="form.channelName" :disabled="form.title === 'Reset Cluster'"></zm-input>
                </zm-form-item>
                <zm-form-item label="endPoint" prop="endPoint">
                    <div slot="label">
                        <tip label="endPoint" id="channel-endPoint"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="form.endPoint" :disabled="form.title === 'Reset Cluster'"></zm-input>
                </zm-form-item>
                <zm-form-item label="dcName" prop="dcName" v-if="form.title !== 'Reset Cluster'">
                    <div slot="label">
                        <tip label="dcName" id="channel-dcName"></tip>
                    </div>
                    <zm-select size="small" v-model="form.dcName" :disabled="!form.dcEditable && (form.title === 'Edit Cluster' && form.broadcast)">
                        <zm-option v-for="item in dcs" :key="item.dcName" :value="item.dcName" :label="item.dcName"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label-width="0" v-if="form.title !== 'Reset Cluster'">
                    <zm-checkbox v-model="form.broadcast" :disabled="form.title !== 'Create Cluster'" @change="changeBroadcast">
                        <tip label="broadcast" id="channel-broadcast"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label-width="0" v-if="form.title !== 'Reset Cluster'">
                    <zm-checkbox v-model="form.autoCreateTopicDisable">
                        <tip label="autoCreateTopicDisable" id="channel-autoCreateTopicDisable"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label-width="0" v-if="form.title !== 'Reset Cluster'">
                    <zm-checkbox v-model="form.operateTopicDisable">
                        <tip label="operateTopicDisable" id="channel-operateTopicDisable"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label="groupName" prop="groupName" v-if="form.title !== 'Reset Cluster'">
                    <div slot="label">
                        <tip label="groupName" id="channel-groupName"></tip>
                    </div>
                    <zm-select size="small" v-model="form.groupName" allow-create filterable
                    :disabled="form.title === 'Edit Cluster' && form.broadcast">
                        <zm-option v-for="item in groups" :key="item.groupName" :value="item.groupName" :label="item.groupName"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="weight" prop="weight" v-if="form.title !== 'Reset Cluster'">
                    <div slot="label">
                        <tip label="weight" id="channel-weight"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.weight" :min="0" :max="99"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="sensitiveConfigurationType" label-width="200px" prop="sensitiveConfigurationType" v-if="form.title !== 'Edit Cluster'">
                    <div slot="label">
                        <tip label="sensitiveConfigurationType" id="channel-sensitiveConfigurationType"></tip>
                    </div>
                    <zm-radio-group size="small" v-model="form.sensitiveConfigurationType">
                        <zm-radio label="LOCAL"></zm-radio>
                        <zm-radio label="CSMS"></zm-radio>
                    </zm-radio-group>
                </zm-form-item>
                <zm-form-item label="userName" prop="userName" v-if="form.title !== 'Edit Cluster'">
                    <div slot="label">
                        <tip label="userName" id="channel-userName"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="form.userName"></zm-input>
                </zm-form-item>
                <zm-form-item label="password" prop="password" v-if="form.title !== 'Edit Cluster'">
                    <div slot="label">
                        <tip label="password" id="channel-password"></tip>
                    </div>
                    <zm-input size="small" v-model="form.password"></zm-input>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="dialogFormVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save()" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Migrate Topics" :visible.sync="migrationVisible" append-to-body>
            <zm-row class="migratable-topic-wrapper">
                <zm-col :span="12">
                    <p>
                        <b>from  </b>
                        <zm-select size="small" v-model="migrationForm.fromId" @change="fetchTopicList" style="width: 70%" filterable clearable>
                            <zm-option v-for="item in fromList" :key="item.id" :value="item.id" :label="item.channelName"></zm-option>
                        </zm-select>
                    </p>
                    <div class="user-list">
                        <zm-input size="small" class="search-topic-input" placeholder="Search topics" v-model.trim="searchTopics"></zm-input><br>
                        <zm-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" v-if="migrationForm.fromId">ALL</zm-checkbox>
                        <zm-checkbox-group size="small"  vertical v-model="migrationForm.topicIds" @change="handleSelectionChange">
                            <zm-checkbox v-for="item in topics" :key="item.id" :label="item.id" :disabled="!item.active">{{ item.name }}</zm-checkbox>
                        </zm-checkbox-group>
                    </div>
                </zm-col>
                <zm-col :span="12">
                    <p>
                        <b>to  </b>
                        <zm-select size="small" v-model="migrationForm.migrateChannelId" style="width: 70%" filterable clearable>
                            <zm-option v-for="item in toList" :key="item.id" :value="item.id" :label="item.channelName"></zm-option>
                        </zm-select>
                    </p>
                    <div class="user-list">
                        <zm-checkbox-group size="small" vertical v-model="migrationForm.topicIds" @change="handleSelectionChange">
                            <zm-checkbox v-for="item in showTopicList" :key="item.id" :label="item.id">{{ item.name }}</zm-checkbox>
                        </zm-checkbox-group>
                    </div>
                </zm-col>
            </zm-row>
            <zm-form class="migrate-form">
                <zm-form-item label="forceMigrate">
                    <div slot="label">
                        <tip label="forceMigrate" id="channel-migrate-forceMigrate"></tip>
                    </div>
                    <zm-checkbox v-model="migrationForm.forceMigrate"></zm-checkbox>
                </zm-form-item>
                <zm-form-item label="subscriberRatioForOld">
                    <div slot="label">
                        <tip label="subscriberRatioForOld" id="channel-migrate-subscriberRatioForOld"></tip>
                    </div>
                    <zm-input-number size="small" v-model="migrationForm.subscriberRatioForOld" :min="10" :max="100" :step="10">
                    </zm-input-number>
                </zm-form-item>
                <zm-form-item label="retainDataDays">
                    <div slot="label">
                        <tip label="retainDataDays" id="channel-migrate-retainDataDays"></tip>
                    </div>
                    <zm-input-number size="small" v-model="migrationForm.retainDataDays" :min="0" :max="7" :step="1">
                    </zm-input-number>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="migrationVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="doMigrate()" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Expand Topics" :visible.sync="expandVisible" append-to-body>
            <zm-form label-width="180px">
                <zm-form-item label="expandBrokerIdSet" label-width="180px">
                    <div slot="label">
                        <tip label="expandBrokerIdSet" id="channel-expand-expandBrokerIdSet"></tip>
                    </div>
                    <zm-select v-model="expandForm.expandBrokerIdSet" multiple size="small" :checkbox-options="nodeInfos">
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="expandRatio">
                    <div slot="label">
                        <tip label="expandRatio" id="channel-expand-expandRatio"></tip>
                    </div>
                    <zm-input-number v-model="expandForm.expandRatio" size="small" :min="0" :step="0.01"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="increaseChannels">
                    <div slot="label">
                        <tip label="increaseChannels" id="channel-expand-increaseChannels"></tip>
                    </div>
                    <zm-input-number v-model="expandForm.increaseChannels" size="small" :min="0"></zm-input-number>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="expandVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="doExpand()" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Verify Topics" :visible.sync="verifyVisible" append-to-body>
            <zm-form :model="verifyForm" :rules="verifyRules" ref="verifyFormRule">
                <zm-form-item label="expandBrokerIdSet" label-width="180px">
                    <div slot="label">
                        <tip label="expandBrokerIdSet" id="channel-verify-expandBrokerIdSet"></tip>
                    </div>
                    <zm-select v-model="verifyForm.expandBrokerIdSet" multiple size="small" :checkbox-options="nodeInfos">
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="expandTotalCount" label-width="180px" prop="expandTotalCount">
                    <div slot="label">
                        <tip label="expandTotalCount" id="channel-verify-expandTotalCount"></tip>
                    </div>
                    <zm-input-number v-model="verifyForm.expandTotalCount" size="small" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item>
                    <zm-checkbox v-model="verifyForm.isLastVerifyBroadcastChannel">
                        <tip label="isLastVerifyBroadcastChannel" id="channel-verify-isLastVerifyBroadcastChannel"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item>
                    <zm-checkbox v-model="verifyForm.recovery">
                        <tip label="recovery" id="channel-verify-recovery"></tip>
                    </zm-checkbox>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="verifyVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="doVerify()" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Verify Expand Channel" :visible.sync="verifyResVisible" append-to-body width="80%" show-close>
            <verify-res :data="verifyRes" :verifyForm="verifyForm"></verify-res>
        </zm-dialog>
        <zm-dialog title="DCs" :visible.sync="dcVisible" append-to-body>
            <div style="text-align: right" v-if="hasPermission">
                <zm-input size="small" v-if="dcForm.isEdit" v-model.trim="dcForm.dcName" style="width: 200px; margin-right: 5px"></zm-input>
                <zm-button size="small" v-if="dcForm.isEdit" @click="submitDC" type="icon" title="submit" icon="zm-icon-ok" :loading="loading"></zm-button>
                <zm-button size="small" v-if="dcForm.isEdit" @click="dcForm.isEdit = false" type="icon" title="cancel" icon="zm-icon-close"></zm-button>
                <zm-button size="small" @click="dcForm.isEdit = true" type="icon" icon="zm-icon-add" title="create DC" v-else></zm-button>
            </div>
            <zm-table :data="dcs" v-loading="loading">
                <zm-table-column prop="dcName" label="dcName"></zm-table-column>
                <zm-table-column prop="dcBackupChannelName" label="dcBackupChannelName"></zm-table-column>
                <zm-table-column align="right">
                    <template slot-scope="scope">
                        <zm-button size="small" @click="showAssignColdBackup(scope.row)" type="icon" title="assign dc backup"
                        icon="zm-icon-edit" v-if="role === 'SUPER_ADMIN' || role === 'ADMIN'"></zm-button>
                        <zm-button size="small" @click="deleteDC(scope.row.id)" type="icon" title="delete DC" icon="zm-icon-delete"
                        v-if="role === 'SUPER_ADMIN' || role === 'ADMIN'"></zm-button>
                    </template>
                </zm-table-column>
            </zm-table>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="dcVisible = false">Close</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Assign DC Backup" :visible="coldForm.visible">
            <zm-form>
                <zm-form-item label="coldBackupChannelName">
                    <div slot="label">
                        <tip label="coldBackupChannelName" id="channel-backup-coldBackupChannelName"></tip>
                    </div>
                    <zm-select size="small" v-model="coldForm.coldBackupChannelName" clearable>
                        <zm-option v-for="item in coldForm.list" :key="item.channelName"
                        :value="item.channelName" :label="item.channelName"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item>
                    <zm-checkbox v-model="coldForm.forceUpdate">
                        <tip label="forceUpdate" id="channel-dcbackup-forceUpdate"></tip>
                    </zm-checkbox>
                </zm-form-item>
            </zm-form>
            <div slot="footer">
                <zm-button size="small" @click="coldForm.visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="saveColdBackup" :loading="coldForm.loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Assign Hot Backup" :visible="hotForm.visible">
            <zm-form>
                <zm-form-item label="dcName">
                    <div slot="label">
                        <tip label="dcName" id="channel-hotbackup-dcName"></tip>
                    </div>
                    <zm-select size="small" v-model="hotForm.dcName" clearable @change="fetchAssignHotBackup">
                        <zm-option v-for="item in dcs" :key="item.dcName"
                        :value="item.dcName" :label="item.dcName"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="hotBackupChannelName">
                    <div slot="label">
                        <tip label="hotBackupChannelName" id="channel-hotbackup-hotBackupChannelName"></tip>
                    </div>
                    <zm-select size="small" v-model="hotForm.hotBackupChannelName" clearable>
                        <zm-option v-for="item in hotForm.list" :key="item.channelName"
                        :value="item.channelName" :label="item.channelName"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item>
                    <zm-checkbox v-model="hotForm.forceUpdate">
                        <tip label="forceUpdate" id="channel-hotbackup-forceUpdate"></tip>
                    </zm-checkbox>
                </zm-form-item>
            </zm-form>
            <div slot="footer">
                <zm-button size="small" @click="hotForm.visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="saveHotBackup" :loading="hotForm.loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Summary" :visible.sync="summaryVisible" append-to-body>
            <zm-button size="small" @click="showSentinelSummary()" class="btn-in-line" plain>Sentinel Summary</zm-button>
            <zm-button size="small" @click="showAllocationSummary()" class="btn-in-line" plain>Allocation Summary</zm-button>
            <zm-button size="small" @click="showResourceSummary()" class="btn-in-line" plain>Resource Summary</zm-button>
            <zm-button size="small" @click="showBrokerSummary()" class="btn-in-line" plain>Broker Summary</zm-button>
            <pre>{{summaryData}}</pre>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="summaryVisible = false">Close</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Upload From Kafka Manage" :visible.sync="mqVisible" append-to-body width="80%">
            <zm-table :data="mqClusters" v-loading="mqLoading" @selection-change="handleKafkaSelectionChange">
                <zm-table-column type="selection"></zm-table-column>
                <zm-table-column prop="dcName" label="dcName" width="110px">
                </zm-table-column>
                <zm-table-column prop="groupName" label="groupName">
                    <template slot-scope="scope">
                        <zm-input v-model="scope.row.groupName"></zm-input>
                    </template>
                </zm-table-column>
                <zm-table-column prop="channelName" label="channelName">
                </zm-table-column>
                <zm-table-column prop="broadcast" label="broadcast" width="100px">
                    <template slot-scope="scope">
                        <zm-checkbox v-model="scope.row.broadcast"></zm-checkbox>
                    </template>
                </zm-table-column>
                <zm-table-column prop="weight" label="weight" width="130px">
                    <template slot-scope="scope">
                        <zm-input-number v-model="scope.row.weight" :min="0" style="width: 90px"></zm-input-number>
                    </template>
                </zm-table-column>
                <zm-table-column prop="sensitiveConfigurationType" label="sensitiveConfigurationType"></zm-table-column>
                <zm-table-column prop="endPoint" label="endPoint" show-overflow-tooltip></zm-table-column>
            </zm-table>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="mqVisible = false">Close</zm-button>
                <zm-button size="small" style="margin-left: 10px;"  type="primary" @click="submitUploadFromMq" :loading="mqLoading">Submit</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { listChannelWithCredential } from '@/api/kafkaManage'
import { getChannels, createChannel, activeChannel, resetChannel, refreshChannel, deleteChannel,
getChannelById,
uploadSSL,
getActiveGroups, getChannelDcs, deleteChannelDc, createChannelDc, updateChannel, recoveryChannel,
getActiveChannels, getChannelListForMigration, migrateTopics, expandChannel, verifyChannel } from '../../api/index'
import { getMqType } from 'api/index'
import { listColdBackup, updateColdBackup, listHotBackup, updateHotBackup, uploadFromKafka } from 'api/channel'
import channelDetail from './channelDetail'
import verifyRes from './verifyRes'
import { getSentinelSummary, getAllocationSummary, getResourceSummary, getBrokerSummary } from '../../api/sentinel'
import axios from 'axios'
import tip from 'components/ToolTip/index'
export default {
    name: 'channel',
    components: {
        tip,
        verifyRes,
        channelDetail
    },
    data () {
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            initDisplayedColumn: {
                key: 'channel',
                props: ['expand', 'dcName', 'groupName', 'channelName', 'currentLoads', 'weight', 'sensitiveConfigurationType', 'clusterStartupStatus', 'broadcast', 'active', 'endPoint', 'operate']
            },
            isKafka: false,
            list: [],
            dcs: [],
            groups: [],
            search: '',
            role: localStorage.role,
            loading: false,
            dialogFormVisible: false,
            formLabelWidth: '120px',
            form: {
                id: '',
                endPoint: '',
                dcName: '',
                dcEditable: true,
                broadcast: false,
                autoCreateTopicDisable: false,
                operateTopicDisable: false,
                groupName: '',
                channelName: '',
                userName: '',
                password: '',
                weight: 1,
                sensitiveConfigurationType: ''
            },
            activeChannels: [],
            channelTopicList: [],
            migrationForm: {
                fromId: '',
                migrateChannelId: '',
                forceMigrate: false,
                subscriberRatioForOld: 20,
                retainDataDays: 7,
                topicIds: []
            },
            isIndeterminate: false,
            checkAll: false,
            migrationVisible: false,
            inputVisible: false,
            inputValue: '',
            expandForm: {
                channelId: '',
                expandBrokerIdSet: [],
                expandRatio: 0,
                increaseChannels: 0
            },
            expandVisible: false,
            verifyForm: {
                channelId: '',
                expandBrokerIdSet: [],
                expandTotalCount: 0,
                isLastVerifyBroadcastChannel: false,
                recovery: false
            },
            nodeInfos: [],
            verifyVisible: false,
            verifyResVisible: false,
            verifyRes: null,
            verifyRules: {
                expandTotalCount: [
                    { required: true, message: 'please enter expandTotalCount', trigger: 'blur' }
                ]
            },
            searchTopics: '',
            showTopicList: [],
            pageable: {
                pageNumber: 1,
                pageSize: 10,
                total: 0
            },
            fileList: [],
            uploadVisible: false,
            uploadData: {
                channelId: '',
                clientSSLPassword: '',
                sslEndPoint: ''
            },
            headers: {
                'Authorization': `Bearer ` + localStorage.token
            },
            uploadRules: {
                clientSSLPassword: [
                    { required: true, message: 'please enter clientSSLPassword', trigger: 'blur' }
                ],
                sslEndPoint: [
                    { required: true, message: 'please enter sslEndPoint', trigger: 'blur' }
                ]
            },
            dcVisible: false,
            dcForm: {
                dcName: '',
                isEdit: false
            },
            summaryVisible: false,
            summaryData: '',
            coldForm: {
                visible: false,
                loading: false,
                list: [],
                coldBackupChannelName: '',
                dcName: '',
                forceUpdate: false
            },
            hotForm: {
                visible: false,
                loading: false,
                list: [],
                channelName: '',
                dcName: '',
                hotBackupChannelName: '',
                channelId: '',
                forceUpdate: false
            },
            mqClusters: [],
            selecstedMqClusters: [],
            mqLoading: false,
            mqVisible: false,
            rules: {
                userName: [
                    { required: true, message: 'please enter userName', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: 'please enter password', trigger: 'blur' }
                ],
                channelName: [
                    { required: true, message: 'please enter clusterName', trigger: 'blur' }
                ],
                endPoint: [
                    { required: true, message: 'please enter endPoint', trigger: 'blur' }
                ],
                dcName: [
                    { required: true, message: 'please enter dcName', trigger: 'blur' }
                ],
                groupName: [
                    { required: true, message: 'please enter groupName', trigger: 'blur' }
                ],
                weight: [
                    { required: true, message: 'please enter weight', trigger: 'blur' }
                ],
                sensitiveConfigurationType: [
                    { required: true, message: 'please enter sensitiveConfigurationType', trigger: 'blur' }
                ]
            }
        }
    },
    created () {
        if (localStorage.params && localStorage.params !== 'undefined' && localStorage.path === this.$route.path && localStorage.path === this.$route.path) {
            this.search = JSON.parse(localStorage.params).search
        }
        this.fetchData()
        getMqType().then(response => {
            if (response === 'KAFKA') {
                this.isKafka = true
            }
        })
        localStorage.params = ''
        localStorage.path = this.$route.path
    },
    watch: {
        search () {
            this.setURL()
        },
        topics () {
            this.handleCheckedChange(this.migrationForm.topicIds)
        }
    },
    computed: {
        tableData () {
            if (this.search) {
                return this.list.filter(data => {
                    return Object.keys(data).some(key => {
                        return String(data[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1
                    })
                })
            }
            return this.list
        },
        topics () {
            if (this.searchTopics) {
                return this.channelTopicList.filter(data => {
                    return String(data.name).toLowerCase().indexOf(this.searchTopics.toLowerCase()) > -1
                })
            }
            return this.channelTopicList
        },
        fromList () {
            return this.activeChannels.filter(data => {
                return data.id !== this.migrationForm.migrateChannelId
            })
        },
        toList () {
            var isBroadcast = null
            this.activeChannels.map(item => {
                if (item.id === this.migrationForm.fromId) {
                    isBroadcast = item.broadcast
                }
            })
            return this.activeChannels.filter(data => {
                return data.id !== this.migrationForm.fromId && data.broadcast === isBroadcast
            })
        }
    },
    methods: {
        handleCheckAllChange (val) {
            this.isIndeterminate = false
            this.showTopicList = val ? this.topics.filter(item => {
                return item.active
            }) : []
            this.migrationForm.topicIds = val ? this.showTopicList.map(item => { return item.id }) : []
        },
        handleCheckedChange (val) {
            let checkedCount = val.length
            this.checkAll = checkedCount === this.channelTopicList.length
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.channelTopicList.length
            this.migrationForm.topicIds = val
            this.showTopicList = []
            this.channelTopicList.map(data => {
                return val.map(id => {
                    if (data.id === id) {
                        this.showTopicList.push(data)
                    }
                })
            })
        },
        showMQ () {
            this.mqLoading = true
            listChannelWithCredential().then(res => {
                this.mqClusters = res.map(item => {
                    const data = item
                    data.broadcast = false
                    data.weight = 0
                    data.groupName = item.channelName
                    return data
                })
                this.mqVisible = true
                this.mqLoading = false
            }).catch(() => {
                this.mqLoading = false
            })
        },
        submitUploadFromMq () {
            this.mqLoading = true
            uploadFromKafka(this.selecstedMqClusters).then(res => {
                this.$message.success('Upload success')
                this.fetchData()
                this.mqVisible = false
                this.mqLoading = false
            }).catch(() => {
                this.mqLoading = false
            })
        },
        handleKafkaSelectionChange (val) {
            this.selecstedMqClusters = val
        },
        setURL () {
            const { search } = this
            const data = { path: this.$route.path, search }
            localStorage.path = this.$route.path
            localStorage.params = JSON.stringify(data)
        },
        onSort ({ column, prop, order }) {
            const descending = order === 'descending'
            this.list.sort((a, b) => {
            if (a[prop] > b[prop]) {
                return descending ? -1 : 1
            } else if (a[prop] < b[prop]) {
                return descending ? 1 : -1
            } else {
                return 0
            }
            })
        },
        showDescribe (row) {
            localStorage.setItem('channelName', row.channelName)
            this.$router.push('/dashboard/channel/describe/' + row.channelId)
        },
        getAction () {
            return process.env.VUE_APP_API_URL + '/api/v1/cluster/upload/truststore'
        },
        sslUpload (content) {
            const { channelId, clientSSLPassword, sslEndPoint } = this.uploadData
            const data = { channelId, clientSSLPassword, sslEndPoint }
            const formData = new FormData()
            formData.append('file', content.file)
            Object.keys(data).map(item => {
                if (data[item] !== null) {
                    formData.append(item, data[item])
                }
            })
            this.loading = true
            axios({
                method: 'post',
                url: content.action,
                headers: content.headers,
                data: formData
            }).then(res => {
                this.loading = false
                content.onSuccess(res)
            }).catch(err => {
                this.loading = false
                content.onError(err)
            })
        },
        changeBroadcast (val) {
            this.form.groupName = ''
            if (val) {
                this.fetchGroups()
            } else {
                this.groups = []
            }
        },
        fetchGroups () {
            getActiveGroups(this.form.broadcast).then(response => {
                this.groups = response
            })
        },
        fetchDcs () {
                this.loading = true
                getChannelDcs().then(response => {
                    this.dcs = response
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
        },
        showDC () {
            this.fetchDcs()
            this.dcVisible = true
        },
        showSummary () {
            this.loading = true
            getSentinelSummary().then(response => {
                this.summaryData = response
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
            this.summaryVisible = true
        },
        showSentinelSummary () {
            this.summaryData = 'loading...'
            getSentinelSummary().then(response => {
                this.summaryData = response
            })
        },
        showAllocationSummary () {
            this.summaryData = 'loading...'
            getAllocationSummary().then(response => {
                this.summaryData = response
            })
        },
        showResourceSummary () {
            this.summaryData = 'loading...'
            getResourceSummary().then(response => {
                this.summaryData = response
            })
        },
        showBrokerSummary () {
            this.summaryData = 'loading...'
            getBrokerSummary().then(response => {
                this.summaryData = response
            })
        },
        submitDC () {
            if (this.dcForm.dcName) {
                this.loading = true
                const dcName = this.dcForm.dcName
                createChannelDc({ dcName }).then(response => {
                    this.fetchDcs()
                    this.dcForm.dcName = ''
                    this.dcForm.isEdit = false
                    this.$message({
                        message: 'Create DC success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            } else {
                this.$message({
                    message: 'Submit error!',
                    type: 'error'
                })
            }
        },
        deleteDC (id) {
            this.$confirm('This will delete the DC. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteChannelDc(id).then(response => {
                    this.fetchDcs()
                    this.$message({
                        message: 'Delete DC success!',
                        type: 'success'
                    })
                    // this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        openUpload (row) {
            this.uploadData.channelId = row.channelId
            this.uploadData.clientSSLPassword = ''
            this.uploadData.sslEndPoint = ''
            this.uploadVisible = true
        },
        expandHandler (row, expandedRows) {
        },
        submitUpload () {
            if (this.$refs.upload.uploadFiles.length) {
                this.$refs.upload.submit()
            } else {
                const { channelId, clientSSLPassword, sslEndPoint } = this.uploadData
                const data = { channelId, clientSSLPassword, sslEndPoint }
                const formData = new FormData()
                Object.keys(data).map(item => {
                    if (data[item] !== null) {
                        formData.append(item, data[item])
                    }
                })
                this.loading = true
                uploadSSL(formData).then(response => {
                    this.loading = false
                    this.uploadVisible = false
                    this.$message.success('Update success')
                }).catch(() => {
                    this.loading = false
                })
            }
            // if (this.fileList.length) {
                // this.loading = true
                // this.$refs.upload.submit()
            // } else {
            //     this.$message({
            //         message: 'Please select a file to upload!',
            //         type: 'warning'
            //     })
            // }
        },
        uploadSuccess (response, file) {
            this.loading = false
            if (response.body.success) {
                this.uploadVisible = false
                this.$message({
                    message: 'Upload success!',
                    type: 'success'
                })
                this.$refs.upload.clearFiles()
                this.fetchData()
            } else {
                this.$message({
                    message: response.body.errorMessage,
                    type: 'error'
                })
            }
        },
        uploadError (err, file) {
            this.loading = false
            this.$message({
                message: JSON.parse(err.message).message,
                type: 'error'
            })
        },
        tableRowClassName ({ row, rowIndex }) {
            if (!row.active) {
                return 'warning-row'
            // } else if (!row.active && !row.nodeInfos) {
            //     return 'warning-row hide-expand'
            // } else if (row.active && !row.nodeInfos) {
            //     return 'hide-expand'
            } else {
                return ''
            }
        },
        handleSizeChange (val) {
            this.pageable.pageSize = val
            this.fetchData()
        },
        fetchData () {
            this.loading = true
            getChannels().then(response => {
                this.list = response
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        handleSelectionChange (val) {
            let checkedCount = val.length
            this.checkAll = checkedCount === this.channelTopicList.length && checkedCount
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.channelTopicList.length
            this.migrationForm.topicIds = val
            this.showTopicList = []
            this.channelTopicList.map(data => {
                return val.map(id => {
                    if (data.id === id) {
                        this.showTopicList.push(data)
                    }
                })
            })
        },
        fetchTopicList () {
            getChannelListForMigration(this.migrationForm.fromId).then(response => {
                this.channelTopicList = response
                this.showTopicList = []
            })
        },
        fetchChannels () {
            getActiveChannels().then(response => {
                this.activeChannels = response
            })
        },
        showMigration () {
            this.fetchChannels()
            this.migrationForm.migrateChannelId = ''
            this.migrationForm.fromId = ''
            this.migrationForm.topicIds = []
            this.migrationForm.forceMigrate = false
            this.migrationForm.subscriberRatioForOld = 20
            this.migrationForm.retainDataDays = 7
            this.channelTopicList = []
            this.showTopicList = []
            this.migrationVisible = true
        },
        doMigrate () {
            const { fromId, migrateChannelId, topicIds, forceMigrate, subscriberRatioForOld, retainDataDays } = this.migrationForm
                if (fromId && migrateChannelId) {
                    this.loading = true
                    const data = { migrateChannelId, topicIds, forceMigrate, subscriberRatioForOld, retainDataDays }
                    migrateTopics(data).then(response => {
                        this.$message({
                            message: 'Submit migrate topic task success',
                            type: 'success'
                        })
                        this.migrationVisible = false
                        this.loading = false
                        this.$refs.migrationForm.resetFields()
                    }).catch(() => {
                        this.loading = false
                    })
                } else {
                    this.loading = false
                    this.$message({
                        message: 'Submit error!',
                        type: 'error'
                    })
                    return false
                }
        },
        doExpand () {
            if (this.expandForm.expandBrokerIdSet.length) {
                this.$confirm('This will expand the topics. Continue?', 'Warning', {
                    confirmButtonText: 'Expand',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.loading = true
                    expandChannel(this.expandForm).then(response => {
                        this.$message({
                            duration: 0,
                            showClose: true,
                            type: 'success',
                            message: 'Expand success.ExpandTotalCount is : ' + response.expandTotalCount
                        })
                        this.loading = false
                        this.expandVisible = false
                    }).catch(() => {
                        this.loading = false
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Expand canceled'
                    })
                })
            } else {
                this.$message({
                    type: 'warning',
                    message: 'Please input expandBrokerIdSet'
                })
            }
        },
        doVerify () {
            this.$refs.verifyFormRule.validate((valid) => {
                if (valid) {
                    this.$confirm('This will verify the topics. Continue?', 'Warning', {
                        confirmButtonText: 'Verify',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }).then(() => {
                        verifyChannel(this.verifyForm).then(response => {
                            this.verifyVisible = false
                            this.verifyResVisible = true
                            this.verifyRes = response
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: 'Verify canceled'
                        })
                    })
                }
            })
        },
        resetForm () {
            this.$refs.form.resetFields()
        },
        showCreate () {
            this.changeBroadcast()
            this.fetchDcs()
            this.form.title = 'Create Cluster'
            this.form.channelName = ''
            this.form.dcEditable = true
            this.form.dcName = ''
            this.form.broadcast = false
            this.form.autoCreateTopicDisable = false
            this.form.operateTopicDisable = false
            this.form.groupName = ''
            this.form.endPoint = ''
            this.form.userName = ''
            this.form.password = ''
            this.form.weight = 1
            this.form.sensitiveConfigurationType = ''
            this.dialogFormVisible = true
        },
        refreshChannel (row) {
            this.$confirm('This will refresh the cluster. Continue?', 'Warning', {
                confirmButtonText: 'Refresh',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                refreshChannel(row.id).then(response => {
                    this.fetchData()
                    this.$message({
                        message: 'Refresh cluster success!',
                        type: 'success'
                    })
                    // this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Refresh canceled'
                })
            })
        },
        resetChannel (row) {
            this.form.title = 'Reset Cluster'
            this.form.id = row.id
            this.form.channelName = row.channelName
            this.form.endPoint = row.endPoint
            this.form.userName = row.userName
            this.form.password = row.password
            this.form.weight = 1
            this.form.sensitiveConfigurationType = row.sensitiveConfigurationType
            this.form.dcName = row.dcName
            this.form.groupName = row.groupName
            this.dialogFormVisible = true
        },
        showEditChannel (row) {
            this.groups = []
            this.fetchDcs()
            this.form.title = 'Edit Cluster'
            this.form.id = row.id
            this.form.channelName = row.channelName
            this.form.endPoint = row.endPoint
            this.form.userName = row.userName
            this.form.password = row.password
            this.form.weight = row.weight
            this.form.sensitiveConfigurationType = row.sensitiveConfigurationType
            this.form.dcName = row.dcName
            this.form.broadcast = row.broadcast
            this.form.autoCreateTopicDisable = row.autoCreateTopicDisable
            this.form.operateTopicDisable = row.operateTopicDisable
            if (row.dcName) {
                this.form.dcEditable = false
            } else {
                this.form.dcEditable = true
            }
            this.form.groupName = row.groupName || ''
            this.dialogFormVisible = true
        },
        save () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.loading = true
                    const { id, channelName, dcName, broadcast, groupName, endPoint, userName, password, weight, sensitiveConfigurationType, autoCreateTopicDisable, operateTopicDisable } = this.form
                    const data = { channelName, dcName, broadcast, groupName, endPoint, userName, password, weight, sensitiveConfigurationType, autoCreateTopicDisable, operateTopicDisable }
                    if (this.form.title === 'Create Cluster') {
                        createChannel(data).then(response => {
                            this.fetchData()
                            this.$message({
                                message: 'Submit create channel success!',
                                type: 'success'
                            })
                            this.dialogFormVisible = false
                            this.$refs.form.resetFields()
                        }).catch(() => {
                            this.loading = false
                        })
                    } else if (this.form.title === 'Reset Cluster') {
                        resetChannel(id, data).then(response => {
                            this.fetchData()
                            this.$message({
                                message: 'Reset cluster success!',
                                type: 'success'
                            })
                            this.dialogFormVisible = false
                            this.$refs.form.resetFields()
                        }).catch(() => {
                            this.loading = false
                        })
                    } else if (this.form.title === 'Edit Cluster') {
                        updateChannel(id, data).then(response => {
                            this.fetchData()
                            this.$message({
                                message: 'Update cluster success!',
                                type: 'success'
                            })
                            this.dialogFormVisible = false
                            this.$refs.form.resetFields()
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                } else {
                    this.loading = false
                    this.$message({
                        message: 'Submit error!',
                        type: 'error'
                    })
                    return false
                }
            })
        },
        showRecovery (id) {
            this.$confirm('This will recovery the cluster. Continue?', 'Warning', {
                confirmButtonText: 'Recovery',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                recoveryChannel(id).then(response => {
                    this.$message({
                        message: 'Recovery success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Recovery canceled'
                })
            })
        },
        showExpand (row) {
            this.expandForm.channelId = row.id
            this.expandForm.expandBrokerIdSet = []
            this.expandForm.expandRatio = 0
            this.expandForm.increaseChannels = 0
            row.loading = true
            getChannelById(row.id).then(response => {
                this.expandVisible = true
                this.nodeInfos = []
                row.loading = false
                response.nodeInfos.map(item => {
                    this.nodeInfos.push({
                        value: item.id,
                        label: item.id
                    })
                })
            }).catch(() => {
                row.loading = false
            })
        },
        showVerify (row) {
            this.verifyForm.channelId = row.id
            this.verifyForm.expandBrokerIdSet = []
            this.verifyForm.expandTotalCount = 0
            this.verifyForm.isLastVerifyBroadcastChannel = false
            this.verifyForm.recovery = false
            row.loading = true
            getChannelById(row.id).then(response => {
                this.verifyVisible = true
                this.nodeInfos = []
                row.loading = false
                response.nodeInfos.map(item => {
                    this.nodeInfos.push({
                        value: item.id,
                        label: item.id
                    })
                })
            }).catch(() => {
                row.loading = false
            })
        },
        deleteChannel (id) {
            this.loading = true
            const h = this.$createElement
            this.$msgbox({
                title: 'Warning',
                message: h('p', null, [
                    h('b', { style: 'color: #0E71EB' }, 'You should refresh channel to release resources before delete channel！')
                ]),
                showCancelButton: true,
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        const loading = this.$loading({
                            lock: true,
                            spinner: 'zm-icon-loading'
                        })
                        deleteChannel(id).then(response => {
                            loading.close()
                            this.fetchData()
                            done()
                            this.$message({
                                message: 'Submit delete success!',
                                type: 'success'
                            })
                        }).catch(() => {
                            loading.close()
                            this.loading = false
                        })
                    } else {
                        this.loading = false
                        done()
                        this.$message({
                            type: 'info',
                            message: 'Delete canceled'
                        })
                    }
                }
            })
        },
        showMonitor (id) {
            this.$router.push({
                path: '/dashboard/monitor',
                query: {
                    key: 'channelId',
                    value: id
                }
            })
        },
        showAssignColdBackup (row) {
            listColdBackup(row.dcName).then(response => {
                this.coldForm.visible = true
                this.coldForm.list = response
                this.coldForm.coldBackupChannelName = row.dcBackupChannelName
                this.coldForm.dcName = row.dcName
                this.coldForm.forceUpdate = false
            })
        },
        saveColdBackup () {
            const { coldBackupChannelName, dcName, forceUpdate } = this.coldForm
            const data = { coldBackupChannelName, dcName, forceUpdate }
            this.coldForm.loading = true
            updateColdBackup(data).then(response => {
                this.fetchDcs()
                this.coldForm.visible = false
                this.coldForm.loading = false
                this.$message.success('Update success')
            }).catch(() => {
                this.coldForm.loading = false
            })
        },
        showAssignHotBackup (row) {
            this.fetchDcs()
            this.hotForm.channelName = row.channelName
            this.hotForm.dcName = ''
            this.hotForm.channelId = row.channelId
            this.hotForm.hotBackupChannelName = ''
            getChannelById(row.id).then(response => {
                this.hotForm.hotBackupChannelName = response.assignBackupChannelName
            })
            this.hotForm.forceUpdate = false
            this.hotForm.visible = true
        },
        fetchAssignHotBackup () {
            this.hotForm.hotBackupChannelName = ''
            const { channelName, dcName } = this.hotForm
            if (dcName) {
                listHotBackup(channelName, dcName).then(response => {
                    this.hotForm.list = response
                })
            } else {
                this.hotForm.list = []
            }
        },
        saveHotBackup () {
            const { hotBackupChannelName, channelId, forceUpdate } = this.hotForm
            const data = { hotBackupChannelName, channelId, forceUpdate }
            this.hotForm.loading = true
            updateHotBackup(data).then(response => {
                this.hotForm.visible = false
                this.hotForm.loading = false
                this.$message.success('Update success')
            }).catch(() => {
                this.hotForm.loading = false
            })
        },
        activeChannel (row) {
            this.loading = true
            this.$confirm('This will change the status. Continue?', 'Warning', {
                confirmButtonText: 'Change',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                activeChannel(row.id, !row.active).then(response => {
                    this.fetchData()
                    this.$message({
                        message: 'Change status success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Change canceled'
                })
            })
        },
        handleCommand (command) {
            if (command.command === 'refreshChannel') {
                this.refreshChannel(command.param)
            } else if (command.command === 'resetChannel') {
                this.resetChannel(command.param)
            } else if (command.command === 'openUpload') {
                this.openUpload(command.param)
            } else if (command.command === 'showDescribe') {
                this.showDescribe(command.param)
            } else if (command.command === 'showRecovery') {
                this.showRecovery(command.param)
            } else if (command.command === 'showExpand') {
                this.showExpand(command.param)
            } else if (command.command === 'showVerify') {
                this.showVerify(command.param)
            } else if (command.command === 'deleteChannel') {
                this.deleteChannel(command.param)
            } else if (command.command === 'showMonitor') {
                this.showMonitor(command.param)
            } else if (command.command === 'showAssignHotBackup') {
                this.showAssignHotBackup(command.param)
            }
        }
    }
}
</script>
<style>
.migrate-form {
    margin-top: 22px;
}
.migrate-form.zm-form .zm-form-item {
    margin-bottom: 16px;
}
.btn-contain.zm-dropdown {
    margin: 10px;
    display: inline;
}
.btn-in-line{
    margin: 10px;
}
.search-input{
    float: right;
    margin: 10px;
    width: 200px;
}
.point {
    height: 15px;
    margin-top: 8px;
}
/* .hide-expand .zm-table__expand-column .zm-icon {
  visibility: hidden;
} */
.search-topic-input {
    width: 201px;
    margin: 0 0 10px 29px;
}
.user-list {
    height: 200px;
    overflow-y: auto;
    padding: 10px;
    border: solid 1px #BABACC;
    border-radius: 8px;
}
.zm-tooltip__popper {
    word-break: break-all;
    max-width: 880px;
}
</style>
